// extracted by mini-css-extract-plugin
export default {"wrapper":"vx-z","viewport":"wx-z","container":"xx-z","slide":"yx-z"};